import { useWorkspaceId } from '../auth/WorkspaceState';

const pricingAllowedWorkspaceIds = new Set(['c6iYfapokglNCtx84OEu']);

export function isPricingAllowedWorkspace(workspaceId: string | undefined): boolean {
  return !!workspaceId && pricingAllowedWorkspaceIds.has(workspaceId);
}

export function useIsPricingAllowed(): boolean {
  const workspaceId = useWorkspaceId();
  return isPricingAllowedWorkspace(workspaceId);
}
